import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Line from "../shapes/Line";

const Instagram = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://apps.elfsight.com/p/platform.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <div className="screen-1">
        <div className="flex items-end justify-between py-3">
          <div>
            <span className="uppercase text-primary-500 2xl:text-2xl  text-xl leading-none">
              Our
            </span>
            <div className="flex flex-col md:flex-row items-center md:space-x-6">
              <span className="uppercase  w-full text-primary-500 2xl:text-3xl  text-xl  font-gotham-black leading-none">
                Instagram
              </span>
              <div className="space-y-1 w-full mt-2 md:mt-0 2xl:mt-2">
                <Line width={60} />
                <Line width={120} />
              </div>
            </div>
          </div>
          <div>
            <span className="md:text-base text-xs w-full inline-block">
              <Link
                to={"https://www.instagram.com/yellowdoorenergy/"}
                target="_blank"
                className="text-primary-500 hover:text-secondary-500"
              >
                View All
              </Link>
            </span>
          </div>
        </div>
      </div>
      <div className="screen-1 pt-14" style={{ paddingTop: '0px' }}>
        <div class="elfsight-app-0692c379-f74e-4a27-bde2-97491893b74c" data-elfsight-app-lazy></div>
      </div>
    </>
  );
};

export default Instagram;
